import { useMutation } from 'react-query';
import { useTranslation } from 'react-i18next';
import { CORE_API_SUFFIX, dataFetch } from '../../../axios/customAxios';
import { handleApiError } from '../../requestHelpers/requestHelpers';
import { ApiError, ApiResponse } from '../../../interfaces/apiResponse.type';

export const useSendSnapchatStore = () => {
    const { t } = useTranslation();

    return useMutation<ApiResponse<null>, ApiError<null>, any>(
        (snap: any) => dataFetch.patch(
            `${CORE_API_SUFFIX}organization-settings`,
            snap
        ),
        {
            onError: (error: any) => {
                handleApiError(error, t);
            },
        },
    );
};
